export const langToLocale = (lang) => (lang === "ru" ? "ru-RU" : "en-US");
export const formatDateTime = (value, lang) => new Date(value).toLocaleString(langToLocale(lang));
export const formatTime = (value, lang) => new Date(value).toLocaleTimeString(langToLocale(lang));
